<template>
  <div>
    <div class="contract-text">
      <div>
        <h5 class="headline">{{ this.$t('contract.supplier_rights_and_obligations.headline') }}</h5>
      </div>
      <p>{{ this.$t('contract.supplier_rights_and_obligations.paragraph_one') }}</p>
      <p v-html="$t('contract.supplier_rights_and_obligations.paragraph_two')"></p>
      <p
        class="user-output"
        v-for="(paragraph, index) in paragraphs"
        :key="paragraph"
        v-html="formatParagraph(index, paragraph)"
      ></p>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  data() {
    return {
      paragraphCountOffset: 3 // offset count for dynamic added paragraphs
    };
  },
  methods: {
    formatParagraph(index, paragraph){
      return `3.${index + this.paragraphCountOffset}.\t${paragraph}`
    }
  },
  computed: {
    isDistributorType() {
      return this.$store.getters.isDistributorType;
    },
    compensation() {
      let compensation = this.$store.state.contract
        .supplierRightsAndObligations;
      return compensation.compensationPercentage !== ""
        ? compensation.compensationPercentage
        : this.$t(
            "contract.supplier_rights_and_obligations.placeholder.compensation"
          );
    },
    paragraphs() {
      let ps = [];

      if (!this.isDistributorType) {
        ps.push(
          this.$t("contract.supplier_rights_and_obligations.paragraph_three", {
            compensationPercentage: this.compensation
          })
        );
      }
      ps.push(
        this.$t("contract.supplier_rights_and_obligations.paragraph_four")
      );
      ps.push(
        this.$t("contract.supplier_rights_and_obligations.paragraph_five")
      );
      ps.push(
        this.$t("contract.supplier_rights_and_obligations.paragraph_six")
      );

      return ps;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/SupplierRightsAndObligationsOutput.vue